// extracted by mini-css-extract-plugin
export default {"body":"EmptyDocumentsList_body__wGmZ2","wrapper":"EmptyDocumentsList_wrapper__OlLAa","row":"EmptyDocumentsList_row__WIc2n","buttonRow":"EmptyDocumentsList_buttonRow__RYap7"};